import { messages } from "./config/messages";
import { StyledCarouselBtn } from "./style";
import { TCarouselData } from "./config/types";
import { navigateToWhatsAppContact } from "../../../../utils/helpers";

const HOME_CAROUSEL_IMAGES = {
  HOME_BANNER_ONE: `${process.env.REACT_APP_ASSETS_BASE_URL}/home/home-banner-one.webp`,
  HOME_BANNER_TWO: `${process.env.REACT_APP_ASSETS_BASE_URL}/home/home-banner-two.png`,
  HOME_BANNER_THREE: `${process.env.REACT_APP_ASSETS_BASE_URL}/home/home-banner-three.webp`,
}

export const HOME_CAROUSEL_CARD_LIST: Array<TCarouselData> = [
  {
    imgPath: HOME_CAROUSEL_IMAGES.HOME_BANNER_ONE,
    title: messages.saasProductDevCompanyTitle,
    subtitle: messages.saasProductDevCompanySubtitle,
    carouselBtn: (
      <StyledCarouselBtn
        variant="contained"
        size="large"
        onClick={navigateToWhatsAppContact}
      >
        {messages.saasProductDevCompanyBtn}
      </StyledCarouselBtn>
    ),
  },
  // {
  //   imgPath: imageTwo,
  //   title: messages.saasProductDevCompanyTitle,
  //   subtitle: messages.saasProductDevCompanySubtitle,
  //   carouselBtn: (
  //     <StyledCarouselBtn
  //       variant="contained"
  //       size="large"
  //       onClick={navigateToWhatsAppContact}
  //     >
  //       {messages.saasProductDevCompanyBtn}
  //     </StyledCarouselBtn>
  //   ),
  // },
  {
    imgPath: HOME_CAROUSEL_IMAGES.HOME_BANNER_THREE,
    title: messages.endToEndProductDevTitle,
    subtitle: messages.endToEndProductDevSubtitle,
    carouselBtn: (
      <StyledCarouselBtn
        variant="contained"
        size="large"
        onClick={navigateToWhatsAppContact}
      >
        {messages.endToEndProductDevBtn}
      </StyledCarouselBtn>
    ),
  },
];
